<template>
    <div class="top">
        <img v-for="item in 4" :src="getUrl(item)" :key="item"/>
    </div>
</template>
<script>
export default {
  methods: {
    getUrl(key) {
      return require(`../img/top/${key}.jpg`)
    }
  }
}
</script>
<style lang="less" scoped>
.top {
  img {
    display: flex;
    width: 375px;
    height: auto;
  }
}

</style>
